import { useNavigate } from "react-router";
import { AvisDescriptiveText } from "../form/AvisDescriptiveText";
import { AvisPrimaryButton } from "../buttons";

interface ILandingPageActionProps {
  buttonText: string;
  textKey: string;
  navigateTo: string;
}
export function LandingPageAction(props: Readonly<ILandingPageActionProps>) {
  const { buttonText, textKey, navigateTo } = props;
  const navigate = useNavigate();

  return (
    <div className="avis-col">
      <AvisPrimaryButton
        onClick={() => {
          navigate(navigateTo);
        }}
        label={buttonText}
      />
      <AvisDescriptiveText textKey={textKey} />
    </div>
  );
}
